import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { MessageBarType } from '@fluentui/react';

const { InsertionOrderStatus, InsertionOrdersGridFieldNames } = Constants;

export const CustomizeBudgetKey = 'CustomizeBudget';
export const StandardBudgetType = 'DailyStandard';
export const LifetimeStandardBudgetType = 'LifetimeBudgetStandard';
export const LifetimeBudgetField = 'LifetimeBudget';
export const IconErrorColor = '#A80000';
export const Grey = '#F1F1F1';
export const BlankNumber = '-';

export const EstimateType = Object.freeze({
  Conversions: 'Conversions',
  Clicks: 'Clicks',
  Impressions: 'Impressions',
  Spend: 'Spend',
});

export const Severity = Object.freeze({
  Default: 0,
  Error: 1,
  Warning: 2,
  Recommendation: 3,
  AllCampaigns: 4,
});

export const IconName = Object.freeze({
  [Severity.Error]: 'ErrorBadge',
  [Severity.Warning]: 'Warning',
  [Severity.Recommendation]: 'Insights',
  [Severity.AllCampaigns]: 'OEM',
});

export const ActionType = Object.freeze({
  EditBudget: 'EditBudget',
  AdjustBudget: 'AdjustBudget',
  AddFunds: 'AddFunds',
  FixIt: 'FixIt',
  CreateNew: 'CreateNew',
  Apply: 'Apply',
  Enable: 'Enable',
  ViewDetails: 'ViewDetails',
});

export const ActionTextKey = Object.freeze({
  [ActionType.EditBudget]: _TL_('Edit budget'),
  [ActionType.AdjustBudget]: _TL_('Adjust budget'),
  [ActionType.AddFunds]: _TL_('Add funds'),
  [ActionType.FixIt]: _TL_('Fix it'),
  [ActionType.CreateNew]: _TL_('Create new'),
  [ActionType.Apply]: _TL_('Apply'),
  [ActionType.Enable]: _TL_('Enable'),
  [ActionType.ViewDetails]: _TL_('View details'),
});

export const TooltipChartType = Object.freeze({
  AccountPastDayDailySpend: 1,
  AccountPastDayCumulativeSpend: 2,
  AccountTodayDailySpend: 3,
  AccountTodayCumulativeSpend: 4,
  CampaignPastDayDailySpend: 5,
  CampaignPastDayCumulativeSpend: 6,
  CampaignTodayDailySpend: 7,
  CampaignTodayCumulativeSpend: 8,
});

export const TooltipChartKeyDataTitleKey = Object.freeze({
  SpendOfTheDay: _TL_('Spend of the day'),
  MonthToDateSpend: _TL_('Month to date spend'),
  MonthlySpendLimit: _TL_('Monthly spend limit'),
  DailyBudget: _TL_('Daily budget'),
  LifetimeBudget: _TL_('Lifetime budget'),
});

export const ClickChangeType = Object.freeze({
  Increase: 'Increase',
  Decrease: 'Decrease',
});

export const BudgetActionType = Object.freeze({
  DailyBudget: 'daily',
  LifetimeBudget: 'lifetime',
});

export const TopKeyCardType = Object.freeze({
  SumSpendOfTheMonth: 'SumSpendOfTheMonth',
  SumSpendToDate: 'SumSpendToDate',
  SumMonthlyBudget: 'SumMonthlyBudget',
  SumDailyBudget: 'SumDailyBudget',
  SumTotalBudget: 'SumTotalBudget',
  PrepayBalance: 'PrepayBalance',
  CurrentBalance: 'CurrentBalance',
  BudgetAndSpend: 'BudgetAndSpend',
  InsertionOrder: 'InsertionOrder',

  SpendOfTheMonth: 'SpendOfTheMonth',
  SpendToDate: 'SpendToDate',
  MonthlyBudget: 'MonthlyBudget',
  DailyBudget: 'DailyBudget',
  LifetimeBudget: 'LifetimeBudget',
});

export const MessageBarTypes = Object.freeze({
  [Severity.Error]: MessageBarType.error,
  [Severity.Warning]: MessageBarType.warning,
});

export const InsertionOrderTextKey = Object.freeze({
  NoEndDate: _TL_('No end date'),
  Unlimited: _TL_('Unlimited'),
  NoEndDateLowerCase: _TL_('no end date'),
  UnlimitedLowerCase: _TL_('unlimited'),
});

export const InsertionOrderFieldNameTextKey = Object.freeze({
  [InsertionOrdersGridFieldNames.SpendCapAmount]: _TL_('budget'),
  [InsertionOrdersGridFieldNames.ThruDate]: _TL_('end date'),
  [InsertionOrdersGridFieldNames.Status]: _TL_('status'),
});

export const InsertionOrderStatusTextKey = Object.freeze({
  [InsertionOrderStatus.PendingSystemReview]: _TL_('Pending Microsoft Advertising review'),
  [InsertionOrderStatus.PendingUserReview]: _TL_('Pending review'),
  [InsertionOrderStatus.Active]: _TL_('Active'),
  [InsertionOrderStatus.Declined]: _TL_('Declined'),
  [InsertionOrderStatus.Expired]: _TL_('Expired'),
  [InsertionOrderStatus.Canceled]: _TL_('Canceled'),
  [InsertionOrderStatus.Pending]: _TL_('Not started'),
  [InsertionOrderStatus.Exhausted]: _TL_('Exhausted'),
  [InsertionOrderStatus.PendingBillToPartyChange]: _TL_('Pending billing take over'),
  [InsertionOrderStatus.PendingBillToPartyChangeAndUserReview]: _TL_('Pre-approval required'),
  [InsertionOrderStatus.Queued]: _TL_('Queued'),
});

export const IOAuthzAction = Object.freeze({
  isIOAddAuthorized: 'isIOAddAuthorized',
  isIOUpdateAuthorized: 'isIOUpdateAuthorized',
});

/**
 * The entry point identifier when entering budget center page. The value should be appended to the url search.
 */
export const EntryPoint = Object.freeze({
  directvisit: 'directvisit',
  unknown: 'unknown',
  toolssetup: 'toolssetup', // This value hasn't been applied to Tools/Setup yet, the log can be found from Kusto client log table substrate1
  campaignsgrid: 'campaignsgrid',
  performancegrid: 'performancegrid',
  email: 'email',
  budgetcentersidebar: 'budgetcentersidebar',
  budgetcentercampaignsummarygrid: 'budgetcentercampaignsummarygrid',
  teachingbubble: 'teachingbubble',
  budgetcentercampaignselector: 'budgetcentercampaignselector',
});
